import styled from 'styled-components';

export const PaymentsContainer = styled.div`
    display: flex;
    justify-content: center;
    padding: 8px 20px;
    max-height: 750px;
`;

export const PaymentsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
`;

export const PaymentsCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: 750px;
    padding: 24px 60px 40px 60px;
    border-radius: 40px;
    background-color: #fff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
    border: 1px solid rgba(224, 224, 224, 1);
    width: 606px;
`;
